var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotAvailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 154,
    viewBox: "0 0 240 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2828_38728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.189 15.8217C102.189 15.8217 77.794 -2.22568 53.4072 0.229585C29.0203 2.68485 4.38086 34.1296 4.38086 34.1296L12.2756 40.1138C12.2756 40.1138 53.194 6.16643 75.3546 31.2638C97.5151 56.3612 102.189 15.8217 102.189 15.8217Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M102.189 15.8217C102.189 15.8217 77.794 -2.22568 53.4072 0.229585C29.0203 2.68485 4.38086 34.1296 4.38086 34.1296L12.2756 40.1138C12.2756 40.1138 53.194 6.16643 75.3546 31.2638C97.5151 56.3612 102.189 15.8217 102.189 15.8217Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7632 13.3035H0V67.4219H83.7632V13.3035Z",
    fill: "#EE8B00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M219.33 128.302C217.787 127.992 216.333 127.344 215.072 126.406C213.812 125.467 212.777 124.262 212.044 122.876V122.798L174.662 52L154.088 66.4862L168.638 111.978C169.022 113.174 169.109 114.445 168.891 115.682C168.674 116.918 168.159 118.084 167.391 119.08C166.622 120.076 165.622 120.872 164.477 121.401C163.332 121.929 162.076 122.174 160.815 122.115C149.762 121.612 138.007 121.33 125.794 121.33C62.6988 121.33 11.5488 128.639 11.5488 137.661C11.5488 146.682 62.6988 154 125.794 154C188.888 154 239.999 146.69 239.999 137.684C239.999 134.183 232.349 130.956 219.33 128.302Z",
    fill: "#C9D3DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.453 132.917C100.453 132.917 101.621 136.864 105.087 137.33C108.553 137.795 109.279 141.277 106.098 141.988C102.916 142.698 95.0449 138.238 95.0449 138.238L95.5423 133.224L100.453 132.917Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9757 132.245C32.9757 132.245 28.9652 133.114 28.2388 136.532C27.5125 139.951 23.9915 140.409 23.502 137.18C23.0125 133.951 28.0888 126.458 28.0888 126.458L33.0467 127.351L32.9757 132.245Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5142 73.3035C33.5142 73.3035 29.8194 90.5456 43.1221 97.935C56.4247 105.325 98.3852 92.0219 91.9037 133.903H101.267C101.267 133.903 113.369 99.1666 81.9721 86.8193L72.4431 76.0114L33.5142 73.3035Z",
    fill: "#29333D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.691 60.858L159.506 57.8145L139.587 78.6587L142.771 81.7023L162.691 60.858Z",
    fill: "#EE8B00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M162.691 60.858L159.506 57.8145L139.587 78.6587L142.771 81.7023L162.691 60.858Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.138 59.3655L157.953 56.322L138.034 77.1663L141.219 80.2098L161.138 59.3655Z",
    fill: "#EE8B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.801 63.2011C174.922 57.8423 176.176 50.7289 172.601 47.3129C169.027 43.8969 161.977 45.4719 156.856 50.8307C151.735 56.1895 150.482 63.3029 154.056 66.7189C157.631 70.1349 164.68 68.5599 169.801 63.2011Z",
    fill: "#EE8B00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M169.801 63.2011C174.922 57.8423 176.176 50.7289 172.601 47.3129C169.027 43.8969 161.977 45.4719 156.856 50.8307C151.735 56.1895 150.482 63.3029 154.056 66.7189C157.631 70.1349 164.68 68.5599 169.801 63.2011Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.247 61.7209C173.368 56.3621 174.621 49.2487 171.046 45.8327C167.472 42.4167 160.423 43.9917 155.302 49.3505C150.181 54.7093 148.927 61.8227 152.502 65.2387C156.076 68.6547 163.126 67.0797 168.247 61.7209Z",
    fill: "#EE8B00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M166.05 59.621C169.433 56.0811 170.261 51.3823 167.9 49.126C165.539 46.8698 160.883 47.9105 157.5 51.4504C154.117 54.9904 153.289 59.6892 155.65 61.9454C158.011 64.2016 162.667 63.161 166.05 59.621Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.197 17.7715C135.197 17.7715 131.636 22.9426 128.179 25.4847C127.843 25.729 127.463 25.9048 127.06 26.0021C126.656 26.0994 126.238 26.1163 125.828 26.0518C125.418 25.9873 125.025 25.8426 124.671 25.6261C124.317 25.4096 124.009 25.1255 123.765 24.79C122.51 23.0294 121.326 20.2821 122.897 17.2821L124.934 11.8584C125.462 10.8217 126.298 9.97388 127.327 9.43111C128.356 8.88834 129.527 8.67725 130.681 8.8268C135 9.07943 137.518 14.7321 135.197 17.7715Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.181 12.9717L110.115 19.4454L112.089 30.8769L123.671 21.4269L126.181 12.9717Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.832 16.9821C132.287 15.8053 130.883 14.4543 129.647 12.9558C129.536 13.9707 129.13 14.931 128.481 15.719C127.832 16.507 126.967 17.0887 125.992 17.3927C125.053 17.702 124.035 17.675 123.113 17.3164C122.191 16.9578 121.423 16.2898 120.939 15.4269L126.15 9.26898C126.862 8.35773 127.808 7.65635 128.886 7.23934C129.965 6.82232 131.136 6.70525 132.276 6.90056C133.261 7.07018 134.234 7.30223 135.189 7.5953C137.558 8.38477 139.208 11.7164 141.813 11.8269C142.075 11.8397 142.329 11.9203 142.551 12.0607C142.772 12.2012 142.954 12.3967 143.077 12.6283C143.2 12.8598 143.261 13.1193 143.254 13.3816C143.247 13.6438 143.172 13.8997 143.037 14.1242C141.758 16.2479 138.963 18.9479 135.545 17.8664C134.929 17.6678 134.35 17.3691 133.832 16.9821V16.9821Z",
    fill: "#29333D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.631 17.677C126.631 17.677 128.131 15.7823 126.631 14.7639C125.131 13.7454 122.928 16.477 124.626 18.3007L126.631 17.677Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.79 20.9141L132.6 23.8904C132.584 24.057 132.527 24.217 132.434 24.3561C132.341 24.4951 132.215 24.6089 132.067 24.6872C131.919 24.7654 131.754 24.8057 131.587 24.8045C131.419 24.8032 131.255 24.7604 131.108 24.6799L128.969 23.4956L132.79 20.9141Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M122.368 22.4767C122.368 22.4767 122.85 18.8846 124.144 17.5188C124.144 17.5188 118.294 19.4925 118.16 25.9267L122.368 22.4767Z",
    fill: "#CE8172"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M16.3106 66.0246C16.3106 66.0246 16.0579 28.7851 60.7895 20.9141L34.5079 67.422H16.35L16.3106 66.0246Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.222 34.8323L112.895 27.1191C112.377 23.9735 111.068 21.0109 109.092 18.509C107.116 16.007 104.538 14.0475 101.598 12.8139C99.039 11.7909 96.3635 11.0882 93.6321 10.7218C90.1269 10.2323 85.2163 10.7218 79.7216 12.1665C56.0532 18.3797 38.6847 38.4323 35.0926 62.606L33.5137 73.3034L72.4426 76.0113C72.4426 76.0113 70.4689 64.9586 84.2847 64.9586C98.1005 64.9586 115.595 65.1007 114.222 34.8323Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M76.0742 22.8718C76.0742 22.8718 57.1821 26.1955 36.4189 56.1166L33.5137 73.3034L63.0558 75.4982L76.0742 22.8718Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7374 36.6324C101.424 24.3324 87.1269 14.385 76.9347 22.2008C68.4084 28.7298 58.7769 40.485 58.3979 60.3245C57.7426 96.1272 92.0374 89.7245 138.451 76.0114L136.974 65.5824C136.974 65.5824 81.3953 76.0903 88.9427 58.0272C92.1005 50.4719 95.7795 43.1772 97.7374 36.6324Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M97.7374 36.6324C101.424 24.3324 87.1269 14.385 76.9347 22.2008C68.4084 28.7298 58.7769 40.485 58.3979 60.3245C57.7426 96.1272 92.0374 89.7245 138.451 76.0114L136.974 65.5824C136.974 65.5824 81.3953 76.0903 88.9427 58.0272C92.1005 50.4719 95.7795 43.1772 97.7374 36.6324Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2296 86.906C78.2296 86.906 79.3743 126.498 33.048 133.903L31.2559 125.511C31.2559 125.511 68.3611 116.314 44.3927 91.6744L78.2296 86.906Z",
    fill: "#29333D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M151.201 140.148C153.983 140.148 156.238 139.314 156.238 138.285C156.238 137.256 153.983 136.422 151.201 136.422C148.419 136.422 146.164 137.256 146.164 138.285C146.164 139.314 148.419 140.148 151.201 140.148Z",
    fill: "#668099"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M170.463 135.324C173.244 135.324 175.499 134.49 175.499 133.461C175.499 132.432 173.244 131.598 170.463 131.598C167.681 131.598 165.426 132.432 165.426 133.461C165.426 134.49 167.681 135.324 170.463 135.324Z",
    fill: "#668099"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M189.859 139.051C192.641 139.051 194.896 138.216 194.896 137.187C194.896 136.158 192.641 135.324 189.859 135.324C187.077 135.324 184.822 136.158 184.822 137.187C184.822 138.216 187.077 139.051 189.859 139.051Z",
    fill: "#668099"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M219.56 140.922C222.342 140.922 224.597 140.088 224.597 139.059C224.597 138.03 222.342 137.196 219.56 137.196C216.778 137.196 214.523 138.03 214.523 139.059C214.523 140.088 216.778 140.922 219.56 140.922Z",
    fill: "#668099"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M132.102 134.906C134.945 134.906 137.25 134.05 137.25 132.995C137.25 131.94 134.945 131.085 132.102 131.085C129.26 131.085 126.955 131.94 126.955 132.995C126.955 134.05 129.26 134.906 132.102 134.906Z",
    fill: "#668099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.258 67.5873C137.258 67.5873 150.032 66.2373 151.153 71.2268C152.274 76.2163 149.826 78.861 138.331 75.1742L137.258 67.5873Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.002 67.4217C10.002 67.4217 11.8414 74.8743 19.2072 73.3032C26.573 71.7322 21.3151 62.5901 10.002 67.4217Z",
    fill: "#F4A28C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2828_38728"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 239.999,
    height: 154,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotAvailable);
export default __webpack_public_path__ + "static/media/notAvailable.09ef79d44691f8c26b26ca430ad37a24.svg";
export { ForwardRef as ReactComponent };